import axios from 'axios'
import { getServerHost } from '../utils/get-server-host'
import { useCallback } from 'react'
import { useSetRecoilState } from 'recoil'
import { usersState } from '../states/users-state'

export const useCreateUser = (): ((data) => Promise<boolean>) => {
  const setUsers = useSetRecoilState(usersState)

  return useCallback(async (data) => {
    const response = await axios.post(getServerHost('user'), data)

    if (response.data.user) {
      setUsers((prevValue) => {
        return [...prevValue, data.user]
      })

      return true
    }
    return false
  }, [])
}